/**
 * @module cercaliagl/AssertionError
 */

/**
 * Error object thrown when an assertion failed. This is an ECMA-262 Error,
 * extended with a `code` property.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error}
 */
class AssertionError extends Error {
  /**
   * @param {string} message Message
   * @param {*=} [params] Optional parameters
   */
  constructor(message, params) {
    super();

    /**
     * @type {string}
     */
    this.message = message;

    /**
     * @type {string}
     */
    this.name = 'Cercalia API Error';

    if (params !== undefined) {
      /**
       * @type {*|undefined}
       */
      this.extraParams = params;
    }
  }
}

export function assert(assertion, message, params) {
  if (!assertion) {
    throw new AssertionError(message, params);
  }
}

export default AssertionError;
